export const initializeSessionData = async () => {
  if (sessionStorage.getItem('sessionId')) {
    return true;
  }

  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    
    if (!data.ip) {
      throw new Error("IP alınamadı veya boş döndü.");
    }
    
    const userIpAddress = data.ip;

    const msgUint8 = new TextEncoder().encode(userIpAddress);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    
    const sessionId = hashHex;
    sessionStorage.setItem('sessionId', sessionId);

    const fixedIndices = [
      [5, 2, 4, 1],
      [10, 15, 1, 8],
      [0, 9, 3, 14],
      [2, 11, 7, 12],
      [13, 4, 1, 6],
      [8, 0, 5, 10],
      [14, 2, 9, 3],
      [15, 12, 11, 4],
      [4, 7, 1, 4],
      [7, 1, 10, 13]
    ];

    const typearray = fixedIndices.map(indices => 
      `${sessionId[indices[0]]}${sessionId[indices[1]]}${sessionId[indices[2]]}${sessionId[indices[3]]}`
    );
    
    sessionStorage.setItem('arrgshsr', JSON.stringify(typearray));
    return true;
  } catch (error) {
    console.error("IP alınamadı:", error);
    return false;
  }
};
